export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100/50">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-8 h-8 rounded-lg bg-primary-500/15 flex items-center justify-center flex-shrink-0">
            <i className="ri-mail-send-line text-primary-400"></i>
          </span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">联系我们</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          <div className="p-6 rounded-xl bg-background-50 border border-background-300/30 text-center hover:border-primary-500/20 transition-colors duration-200 cursor-pointer">
            <span className="w-12 h-12 rounded-xl bg-primary-500/10 flex items-center justify-center mx-auto mb-4">
              <i className="ri-mail-line text-xl text-primary-400"></i>
            </span>
            <h3 className="text-sm font-semibold text-foreground-200 mb-1">投稿爆料</h3>
            <p className="text-xs text-foreground-600">admin@91chigua.com</p>
          </div>
          <div className="p-6 rounded-xl bg-background-50 border border-background-300/30 text-center hover:border-accent-500/20 transition-colors duration-200 cursor-pointer">
            <span className="w-12 h-12 rounded-xl bg-accent-500/10 flex items-center justify-center mx-auto mb-4">
              <i className="ri-question-answer-line text-xl text-accent-400"></i>
            </span>
            <h3 className="text-sm font-semibold text-foreground-200 mb-1">入口反馈</h3>
            <p className="text-xs text-foreground-600">反馈入口异常获得优先处理</p>
          </div>
          <div className="p-6 rounded-xl bg-background-50 border border-background-300/30 text-center hover:border-secondary-500/20 transition-colors duration-200 cursor-pointer">
            <span className="w-12 h-12 rounded-xl bg-secondary-500/10 flex items-center justify-center mx-auto mb-4">
              <i className="ri-shake-hands-line text-xl text-secondary-400"></i>
            </span>
            <h3 className="text-sm font-semibold text-foreground-200 mb-1">商务合作</h3>
            <p className="text-xs text-foreground-600">coop@91chigua.com</p>
          </div>
        </div>
      </div>
    </section>
  );
}